import React, { createContext } from 'react';
import {
  FeatureFlagContextData,
  fetchFeatures,
} from '~/contexts/FeatureFlagsContext/types';

export const FeatureFlags = createContext<FeatureFlagContextData>(
  {} as FeatureFlagContextData,
);

export const FeatureFlagsProvider: ({
  children,
}: {
  children: any;
}) => JSX.Element | null = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [features, setFeatures] = React.useState({} as FeatureFlagContextData);

  React.useEffect(() => {
    fetchFeatures()
      .then(res => {
        setFeatures(res.features);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return !isLoading ? (
    <FeatureFlags.Provider value={{ ...features }}>
      {children}
    </FeatureFlags.Provider>
  ) : null;
};

export const useFeatureFlags = () => React.useContext(FeatureFlags);
